export const dateConfig = [
  { label: "Last 7 Days", value: "last7days" },
  { label: "Last 4 Weeks", value: "last4weeks" },
  { label: "Last Month", value: "lastmonth" },
  { label: "Last 3 Months", value: "last3months" },
  { label: "Last 12 Months", value: "last12months" },
  { label: "Last Year", value: "lastyear" },
];

export const referredLeadsConfig = [
  { label: "0", value: { min: 0, max: 0 } },
  { label: "1-5", value: { min: 1, max: 5 } },
  { label: "6-10", value: { min: 6, max: 10 } },
  { label: "11-50", value: { min: 11, max: 50 } },
  { label: "50+", value: { min: 50 } },
];

export const refereAffiliateConfig = [
  { label: "0", value: { min: 0, max: 0 } },
  { label: "1-5", value: { min: 1, max: 5 } },
  { label: "6-10", value: { min: 6, max: 10 } },
  { label: "11-50", value: { min: 11, max: 50 } },
  { label: "50+", value: { min: 50 } },
];

export const docStatusConfig = [
  { label: "Pending", value: "Pending" },
  { label: "Requested", value: "Requested" },
  { label: "Submitted", value: "Submitted" },
  { label: "Partial", value: "Partial" },
  { label: "Completed", value: "Completed" },
];

export const qualifiedEmployeesConfig = [
  { label: "0-100", value: { min: 0, max: 100 } },
  { label: "101-250", value: { min: 101, max: 250 } },
  { label: "251-500", value: { min: 251, max: 500 } },
  { label: "501-1,000", value: { min: 501, max: 1000 } },
  { label: "1,000+", value: { min: 1000 } },
];

export const leadStatusConfig = [
  // { label: "Initiated", value: "Initiated" },
  // { label: "Eligibility In Review", value: "Eligibility In Review" },
  // { label: "Not Eligible", value: "Not Eligible" },
  // { label: "Pending Documents", value: "Pending Documents" },
  // { label: "Calculating Credit", value: "Calculating Credit" },
  // { label: "Credit Calculated", value: "Credit Calculated" },
  // { label: "Wet Sig Docs Sent", value: "Wet Sig Docs Sent" },
  // { label: "Client Mailed Docs", value: "Client Mailed Docs" },
  // { label: "Submitted to IRS", value: "Submitted to IRS" },
  // { label: "Payment Received", value: "Payment Received" },
  // { label: "Contacted", value: "Contacted" },
  // { label: "Qualified", value: "Qualified" },
  { label: "In Review", value: "In Review" },
  { label: "Cancelled", value: "Cancelled" },
  { label: "Booked Call", value: "Booked Call" },
  { label: "Presentation", value: "Presentation" },
  { label: "Not Qualified", value: "Not Qualified" },
  { label: "Census Requested", value: "Census Requested" },
  { label: "Proforma Sent", value: "Proforma Sent" },
  { label: "Contract Sent", value: "Contract Sent" },
  { label: "Contract Signed", value: "Contract Signed" },
  // { label: "Onboarding", value: "On-Boarding" },
];

export const documentTemplateStatusConfig = [
  { label: "Signed", value: "Signed" },
  { label: "Pending", value: "Pending" },
];

export const affiliateTypeConfig = [
  { label: "Regular Affiliate", value: "Regular" },
  { label: "Super Affiliate", value: "Super" },
  { label: "Organization Leader", value: "Leader" },
];

export const dashboardCardConfig = [
  {
    label: "Total Affiliates",
    value: "totalAffiliates",
    imgSrc: require("../assets/img/affiliate.png"),
  },
  {
    label: "Total Employers",
    value: "totalEmployer",
    imgSrc: require("../assets/img/employer.png"),
  },
  {
    label: "Total Estimated Employees",
    value: "totalEstimatedEmployee",
    imgSrc: require("../assets/img/employer.png"),
  },
  {
    label: "Total Qualified Employees",
    value: "totalQualifiedEmployees",
    imgSrc: require("../assets/img/employee.png"),
  },
];

export const categorieConfig = [
  {
    label: "Search",
    name: "search",
    type: "text",
    placeholder: "Search",
  },
  {
    label: "Status",
    name: "status",
    type: "select",
    defaultOption: "All",
    options: [
      { value: "true", label: "Active" },
      { value: "false", label: "Inactive" },
    ],
  },
];

export const topicConfig = [
  {
    label: "Search",
    name: "search",
    type: "text",
    placeholder: "Search",
  },
  {
    label: "Status",
    name: "status",
    type: "select",
    defaultOption: "All",
    options: [
      { value: "true", label: "Active" },
      { value: "false", label: "Inactive" },
    ],
  },
];

export const alphabetArray = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const videoResolutionsConfig = {
  threeTwoZero: 320,
  fiveFourZero: 540,
  sevenTwoZero: 720,
  oneZeroEightZero: 1080,
};

export const bitrateConfig = {
  fiveFourZero: 200000,
  oneZeroEightZero: 400000,
  sevenTwoZero: 800000,
  threeTwoZero: 1500000,
};
